export class Arrachage {
    static jsonMap = {
        nbArbre: 'nbArbre'
    };

    nbArbre: number;
}
